// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type WorkspacesQueryVariables = PrivateSchemaTypes.Exact<{ [key: string]: never; }>;


export type WorkspacesQuery = (
  { __typename?: 'Query' }
  & { workspaces: Array<(
    { __typename?: 'WorkspaceModelAsCollaborator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCollaborator, 'id' | 'name' | 'description' | 'assignedEnrolmentsCount' | 'publishedTopicsCount' | 'is_open'>
    & { tags: Array<(
      { __typename?: 'TagModel' }
      & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
    )>, themes: Array<(
      { __typename?: 'ThemeModelAsEditor' }
      & Pick<PrivateSchemaTypes.ThemeModelAsEditor, 'id' | 'title' | 'topicsCount'>
    ) | (
      { __typename?: 'ThemeModelAsMember' }
      & Pick<PrivateSchemaTypes.ThemeModelAsMember, 'id' | 'title' | 'topicsCount'>
    )>, coverImage?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'DocumentModel' }
      & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
      & { imageVariants: Array<(
        { __typename?: 'ImageVariantModel' }
        & Pick<PrivateSchemaTypes.ImageVariantModel, 'size_key' | 'cdnUrl'>
      )> }
    )> }
  ) | (
    { __typename?: 'WorkspaceModelAsCoordinator' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsCoordinator, 'id' | 'name' | 'description' | 'assignedEnrolmentsCount' | 'publishedTopicsCount' | 'is_open'>
    & { tags: Array<(
      { __typename?: 'TagModel' }
      & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
    )>, themes: Array<(
      { __typename?: 'ThemeModelAsEditor' }
      & Pick<PrivateSchemaTypes.ThemeModelAsEditor, 'id' | 'title' | 'topicsCount'>
    ) | (
      { __typename?: 'ThemeModelAsMember' }
      & Pick<PrivateSchemaTypes.ThemeModelAsMember, 'id' | 'title' | 'topicsCount'>
    )>, coverImage?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'DocumentModel' }
      & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
      & { imageVariants: Array<(
        { __typename?: 'ImageVariantModel' }
        & Pick<PrivateSchemaTypes.ImageVariantModel, 'size_key' | 'cdnUrl'>
      )> }
    )> }
  ) | (
    { __typename?: 'WorkspaceModelAsMember' }
    & Pick<PrivateSchemaTypes.WorkspaceModelAsMember, 'id' | 'name' | 'description' | 'assignedEnrolmentsCount' | 'publishedTopicsCount' | 'is_open'>
    & { tags: Array<(
      { __typename?: 'TagModel' }
      & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
    )>, themes: Array<(
      { __typename?: 'ThemeModelAsEditor' }
      & Pick<PrivateSchemaTypes.ThemeModelAsEditor, 'id' | 'title' | 'topicsCount'>
    ) | (
      { __typename?: 'ThemeModelAsMember' }
      & Pick<PrivateSchemaTypes.ThemeModelAsMember, 'id' | 'title' | 'topicsCount'>
    )>, coverImage?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'DocumentModel' }
      & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
      & { imageVariants: Array<(
        { __typename?: 'ImageVariantModel' }
        & Pick<PrivateSchemaTypes.ImageVariantModel, 'size_key' | 'cdnUrl'>
      )> }
    )> }
  )> }
);


export const WorkspacesDocument = gql`
    query workspaces {
  workspaces {
    id
    name
    description
    assignedEnrolmentsCount
    publishedTopicsCount
    is_open
    tags {
      id
      name
    }
    themes {
      id
      title
      topicsCount(filters: {name: withCurrentVersion})
    }
    coverImage {
      id
      cdnUrl
      imageVariants {
        size_key
        cdnUrl
      }
    }
  }
}
    `;

/**
 * __useWorkspacesQuery__
 *
 * To run a query within a React component, call `useWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkspacesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WorkspacesQuery, WorkspacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkspacesQuery, WorkspacesQueryVariables>(WorkspacesDocument, options);
      }
export function useWorkspacesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspacesQuery, WorkspacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkspacesQuery, WorkspacesQueryVariables>(WorkspacesDocument, options);
        }
export type WorkspacesQueryHookResult = ReturnType<typeof useWorkspacesQuery>;
export type WorkspacesLazyQueryHookResult = ReturnType<typeof useWorkspacesLazyQuery>;
export type WorkspacesQueryResult = Apollo.QueryResult<WorkspacesQuery, WorkspacesQueryVariables>;